// CohortUpdateComponent.js
import React from "react";
import { useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import styles from "./CohortUpdateComponentPartner.module.css";
import leftArrow from "../../../assests/leftArrow.svg";

const CohortUpdateComponent = (props) => {
  const navigate = useNavigate();
  const goback1 = () => navigate(-1);

  return (
    <div className={styles.mainContainer}>
      <Sidebar />

      <div className={styles.contentContainer}>
        {/* ============ HEADER ============ */}
        <div className={styles.header}>
          <button
            className={styles.backButton}
            onClick={goback1}
            type="button"
          >
            <img src={leftArrow} alt="Go Back" />
          </button>
          <div className={styles.titleBlock}>
            <h2 className={styles.title}>Edit Cohort</h2>
            <p className={styles.subtitle}>
              Add or remove VMIDs from this cohort
            </p>
          </div>
        </div>

        {/* ============ FORM WRAPPER ============ */}
        <div className={styles.formWrapper}>
          {/* ---------- ADD VM SECTION ---------- */}
          <div className={styles.formCard}>
            <div className={styles.cardHeader}>
              <div className={styles.cardIconCircle}>
                <span>➕</span>
              </div>
              <div>
                <div className={styles.cardTitle}>Add VMID</div>
                <div className={styles.cardSubtitle}>
                  Enter a VMID to add to this cohort
                </div>
              </div>
            </div>

            <div className={styles.cardBody}>
              <TextField
                fullWidth
                label="Add VMID"
                name="newNameAttribute"
                value={props.newNameAttribute}
                onChange={props.handleInputChange}
                error={props.inputError}
                helperText={props.inputError ? "Please enter a valid VMID" : ""}
                className={styles.inputField}
                variant="outlined"
                size="small"
              />
              <Button
                className={styles.formButton}
                onClick={props.vmAdded}
              >
                Add VMID
              </Button>
            </div>
          </div>

          {/* ---------- REMOVE VM SECTION ---------- */}
          <div className={styles.formCard}>
            <div className={styles.cardHeader}>
              <div
                className={`${styles.cardIconCircle} ${styles.cardIconCircleRed}`}
              >
                <span>➖</span>
              </div>
              <div>
                <div className={styles.cardTitle}>Remove VMID</div>
                <div className={styles.cardSubtitle}>
                  Enter a VMID to remove from this cohort
                </div>
              </div>
            </div>

            <div className={styles.cardBody}>
              {/* VMID List Box */}
              <div className={styles.vmIdBox}>
                <div className={styles.vmIdBoxHeader}>
                  <span className={styles.vmIdBoxLabel}>Current VMIDs</span>
                  <span className={styles.vmIdBoxCount}>
                    {props.vmIdList?.length || 0}
                  </span>
                </div>
                <div className={styles.vmIdList}>
                  {props.vmIdList?.length > 0 ? (
                    props.vmIdList.map((id, idx) => (
                      <span key={idx} className={styles.vmIdChip}>
                        {id}
                      </span>
                    ))
                  ) : (
                    <span className={styles.vmIdEmpty}>No VMIDs added</span>
                  )}
                </div>
              </div>

              <TextField
                fullWidth
                label="Remove VMID"
                name="machines"
                value={props.removeVmid}
                onChange={props.handleChangeRemoveVmid}
                className={styles.inputField}
                variant="outlined"
                size="small"
              />
              <Button
                className={`${styles.formButton} ${styles.removeBtn}`}
                onClick={props.vmDeleted}
              >
                Remove VMID
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CohortUpdateComponent;